import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { instagramUrl, logoImage, navLinks } from "@/mocks/site";

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || menuOpen;
  const textColor = solid ? "text-foreground-950" : "text-background-50";

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        solid
          ? "bg-background-50 border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="flex h-16 md:h-20 items-center justify-between px-4 md:px-10">
        <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="Definition Films home">
          <img
            src={logoImage}
            alt="Definition Films"
            className={`h-7 md:h-8 w-auto transition-all duration-300 ${
              solid ? "" : "brightness-0 invert"
            }`}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                `font-label text-xs tracking-[0.2em] uppercase transition-colors duration-200 ${
                  textColor
                } ${isActive ? "opacity-100" : "opacity-70 hover:opacity-100"}`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <a
            href={instagramUrl}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            className={`w-8 h-8 flex items-center justify-center ${textColor}`}
          >
            <i className="ri-instagram-line text-lg" />
          </a>
        </nav>

        <button
          type="button"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          onClick={() => setMenuOpen((prev) => !prev)}
          className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${textColor}`}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-6">
          <nav className="flex flex-col gap-5">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                className="font-label text-sm tracking-[0.2em] uppercase text-foreground-950"
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href={instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 font-label text-sm tracking-[0.2em] uppercase text-foreground-950"
            >
              <i className="ri-instagram-line text-lg" /> Instagram
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}